import { Component, Host, h, Prop, Element } from '@stencil/core';
import { AnchorInterface, generateAnchorAttributes, openURL } from '../../../utils/elements-interface';

/**
 * @slot - Designed to define the content of the breadcrumb item.
 */
@Component({
  tag: 'sy-breadcrumb-item',
  styleUrls: ['scss/index.scss', 'scss/_tokens.scss'],
  shadow: true,
})
export class BreadcrumbItem implements AnchorInterface {
  @Element() host: HTMLSyBreadcrumbItemElement;

  /**
   HTML <a> download attribute.
   */
  @Prop() download: string | undefined;

  /**
   * HTML <a> href attribute.
   */
  @Prop() href: string | undefined;

  /**
   * HTML <a> ref attribute.
   */
  @Prop() rel: string | undefined;

  /**
   * HTML <a> target attribute.
   */
  @Prop() target: '_blank' | '_self' | '_parent' | '_top';

  /**
   * If true, this item is referent to the active page.
   */
  @Prop({ reflect: true }) active = false;

  componentWillLoad() {
    if (!this.host.hasAttribute('role')) {
      this.host.setAttribute('role', 'listitem');
    }
  }

  private handleClick = (event: Event) => {
    if (this.href && !this.active) {
      openURL(this.href, event);
    }
  };

  render() {
    return (
      <Host onClick={this.handleClick} {...(this.active ? { 'aria-current': 'page' } : {})}>
        {this.active ? (
          <slot></slot>
        ) : (
          <a {...generateAnchorAttributes(this)}>
            <slot></slot>
          </a>
        )}
      </Host>
    );
  }
}
